// removed by extract-text-webpack-plugin
module.exports = {"share-button":"yh15z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShareModal/ShareButton.scss
// module id = ./src/components/ShareModal/ShareButton.scss
// module chunks = 5